import { useCookies } from 'react-cookie';
import { useCallback } from 'react';

function useAuthCookies() {

    const [ cookies, setCookie ] = useCookies();

    let setCookies = useCallback((data, name = 'accessToken') => {

        const isStaging = window.location.host.includes('paylix.gg');
        const isProduction = window.location.host.includes('paylix.gg');
        const isRealStaging = window.location.host.includes('paylixecommerce-staging.io');
        const isWalletStaging = window.location.host.includes("paylixecommerce-crispy.io");

        let options = {
            path: "/",
            expires: new Date(new Date().getFullYear() + 1, 1, 1, 1, 1, 1, 0),
            sameSite: 'lax',
            secure: false
        }

        let domain = "local-test-paylixecommerce.com";

        if(isStaging) {
            domain = "paylix.gg";
            options.secure = true;
        } else if(isProduction) {
            domain = "paylix.gg";
            options.secure = true;
        } else if(isRealStaging) {
            domain = "paylixecommerce-staging.io";
            options.secure = true;
        } else if(isWalletStaging) {
            domain = "paylixecommerce-crispy.io";
            options.secure = true;
        }

        let sub = ['.oauth', '.developers', '.admin', ''];

        if(!window.location.host.includes("auth")) {
            sub.push('.auth');
        }

        if(!window.location.host.includes("dashboard")) {
            sub.push('.dashboard');
        }

        sub.map((v) => {
            setCookie(name, data, {
                domain: v ? `${v}.${domain}` : domain,
                ...options
            });
        })

    }, []);

    let removeCookies = useCallback((name = 'accessToken') => {

        const isStaging = window.location.host.includes('paylix.gg');
        const isProduction = window.location.host.includes('paylix.gg');
        const isRealStaging = window.location.host.includes('paylixecommerce-staging.io');
        const isWalletStaging = window.location.host.includes('paylixecommerce-crispy.io');


        let options = {
            path: "/",
            expires: new Date(2000, 1, 1, 1, 1, 1, 0),
            sameSite: 'lax',
            secure: false
        }
        let domain = "local-test-paylixecommerce.com";

        if(isStaging) {
            domain = "paylix.gg";
            options.secure = true;
        } else if(isProduction) {
            domain = "paylix.gg";
            options.secure = true;
        } else if(isRealStaging) {
            domain = "paylixecommerce-staging.io";
            options.secure = true;
        } else if(isWalletStaging) {
            domain = "paylixecommerce-crispy.io";
            options.secure = true;
        }

        let sub = ['.auth', '.oauth', '.dashboard', '.developers', '.admin', ''];

        sub.map((v) => {
            setCookie(name, "", {
                domain: v ? `${v}.${domain}` : domain,
                ...options
            });
        })

    }, []);

    return {
        setCookies,
        removeCookies
    }
}

export default useAuthCookies;
